import React from 'react';
import { t } from 'ttag';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import Phisherman from '../../characters/Phisherman';

const BlockUserDodgePhisher: React.FC<ISlide> = ({ defaultHeader, nextSlide, gotoSlide, currentIndex }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: Phisherman,
            text: t`Noooooooo... I have been sending out emails all day! How did I not catch you?`,
            textSpriteName: 'octo-phisherman-1',
            buttonText: t`Next`,
            buttonAction: () => nextSlide(),
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default BlockUserDodgePhisher;
